"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const preload_1 = require("./preload");
const api_1 = require("./api");
const logic_1 = require("./logic");
const getEstimatedFees = (transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const rawGasPrice = yield (0, api_1.getGasPrice)();
    const gasPrice = new bignumber_js_1.BigNumber(rawGasPrice);
    if (["stake", "unstake", "withdraw"].includes(transaction.mode)) {
        return (0, logic_1.getStakingFees)(transaction, gasPrice);
    }
    const { createAccountCostSend, createAccountCostExecution, transferCostSend, transferCostExecution, addKeyCostSend, addKeyCostExecution, receiptCreationSend, receiptCreationExecution, } = (0, preload_1.getCurrentNearPreloadData)();
    let sendFee = transferCostSend.plus(receiptCreationSend);
    let executionFee = transferCostExecution.plus(receiptCreationExecution);
    if ((0, logic_1.isImplicitAccount)(transaction.recipient)) {
        sendFee = sendFee.plus(createAccountCostSend).plus(addKeyCostSend);
        executionFee = executionFee.plus(createAccountCostExecution).plus(addKeyCostExecution);
    }
    const fees = sendFee.multipliedBy(gasPrice).plus(executionFee.multipliedBy(gasPrice));
    return fees;
});
exports.default = getEstimatedFees;
//# sourceMappingURL=js-getFeesForTransaction.js.map